export default __webpack_public_path__ + "app/images/img-404.svg";